
//essencial
export const generateRecaptchaTokenEssencial = () => {
    grecaptcha.ready(async () => {
        const token = await grecaptcha.execute(process.env.VUE_APP_GOOGLE_RECAPTCHA_SITEKEY, { action: 'LOGIN' });
        console.log(token)
        return token;
    });
}
//enterprise
export const generateRecaptchaToken = (action) => {
    return new Promise(async (resolve, reject) => {
        grecaptcha.enterprise.ready(async () => {
            try {
                const token = await grecaptcha.enterprise.execute(process.env.VUE_APP_GOOGLE_RECAPTCHA_SITEKEY, { action: action });
                resolve(token);
            } catch (error) {
                reject(error);
            }
        });
    });
};

export const handleRecaptcha = async (action) => {
    try {
        const token = await generateRecaptchaToken(action);
        return token;
    } catch (error) {
        console.error('Error al generar el token:', error);
    }
};

export const Action = Object.create(null, {
    CREATE: { value: "Create" },
    CREATE_REMOTE: { value: "Create_Remote" },
    READ: { value: "Read" },
    UPDATE: { value: "Update" },
    DELETE: { value: "Delete" },
    LOGIN: { value: "Login" },
    FIND: { value: "Find" }
});
